import React, { useContext } from "react";
import { EPMRProvider } from "./context";
import ManageEpmr from "./ManageEpmr";

import { PermisionDenied } from "../../../../common/commonComponents";
import { pages } from "views/pages/manage/common/constant";
import { RolePermissions, PermissionContext } from "appContext";

const Epmr = () => {
  const userPermissions = RolePermissions(
    useContext(PermissionContext),
    pages["epmrListing"]["id"]
  );

  // `userPermissions` check
  return userPermissions.length ? (
    <EPMRProvider>
      <ManageEpmr />
    </EPMRProvider>
  ) : (
    <PermisionDenied />
  );
};

export default Epmr;
